exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-contact-tsx": () => import("./../../../src/pages/contact.tsx" /* webpackChunkName: "component---src-pages-contact-tsx" */),
  "component---src-pages-equity-tsx": () => import("./../../../src/pages/equity.tsx" /* webpackChunkName: "component---src-pages-equity-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-odds-tsx": () => import("./../../../src/pages/odds.tsx" /* webpackChunkName: "component---src-pages-odds-tsx" */)
}

